
import "./SecurityPermission.scss";
import BaseComponent from "../../shared/baseComponent";
import { GetPermissionData } from "./GenarateTreeData";
import SecurityPermissionList from "./SecurityPermissionList";
import FormFieldGroup from "../../components/UI Element/FormGrop/FormFieldGroup";
import securityPermissionServices from "../../services/domainServices/securityPermissionServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";

export default class SecurityPermission extends BaseComponent {

  //** Constructor  and Component method */
  constructor(props) {
    super(props);
    this.securityPermissionServices = new securityPermissionServices();
    this.userId =getAuthProps();
    this.state = {
      ...this.state,
      formData: this.securityPermissionServices.dataItem,
      setRoleList: [],
      setIsLoad: false,
      selectedId: null,
      permissionItem: [],
      setModelshow: false,
      setPermissionTreeData: []
    };
    this.onPermissionItemSet = this.onPermissionItemSet.bind(this);
    this.securityPermissionServices.onUpdateState = this.updateState.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSavePermission = this.handleSavePermission.bind(this);
  }

  componentDidMount() {
    this.securityPermissionServices.onGetRoles();
  }

  handleChange(name, value) {
    const newValue = parseInt(value);
    if (name === "roleId") {
      let detail = this.state.formData;
      detail[name] = newValue;
      this.setState({ formData: { ...detail } });
      this.setState({ setModelshow: false });
      this.setState({ selectedId: newValue });
    }
  }

  handleSavePermission() {
    
    if (this.state.permissionItem && this.state.permissionItem.length > 0) {
      let permissionSettingList = GetPermissionData(this.state.permissionItem);
      const transformedData = permissionSettingList.map((item) => ({
        securitySettingId: item.securitySettingId,
        securityKeyId: item.securityKeyId,
        roleId: item.roleId,
      }));
      const requestData = {
        securityPermissionsList: transformedData,
        createdBy: this.userId ?this.userId.Userid: 0 ,
      };
      this.securityPermissionServices.onSavePermission(requestData);
    }
  }


  onPermissionItemSet(permissionTreeItem) {
    this.setState({ permissionItem: permissionTreeItem });
  }

  handleClick() {
    if (this.state.selectedId) {
      this.setState({ setModelshow: true });
      this.securityPermissionServices.onShowSecurity(this.state.selectedId);
    } else {
      this.securityPermissionServices.apiService.serviceManager.swalServices.WarningToaster("Please choose a role to proceed.");
    }
  }

  //** Render Method  */
  render() {
    return (
      <>
        <div>
          <div className="accordion mb-3" id="accordionExample">
            <div className="card accordion-item active">
              <div id="accordionOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <div className="card-body">
                    <div className="d-flex align-items-end">
                      <div className="w-50">
                        {this.securityPermissionServices.formFields.map((Item, index) => {
                          return (
                            <>
                              <FormFieldGroup
                                className="col-md-3"
                                column={Item}
                                value={this.state.formData[Item.fieldName] ? this.state.formData[Item.fieldName] : ""}
                                options={this.state.setRoleList}
                                onChange={(event) =>
                                  this.handleChange(Item.fieldName, event.target.value)
                                }
                                key={index}
                              />
                            </>
                          );
                        })}
                      </div>
                      <div className="button-sec">
                        <button className="tab-title btn-hover color-3 active security-show-button" onClick={this.handleClick} >
                          Show Permission
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.state.setModelshow === true ?
            <>
              <div className="accordion" id="accordionExample">
                <div className="card accordion-item active">
                  <div id="accordionOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="card-body">
              <div className="security-save-button">
                <button className="tab-title btn-hover color-3 active" onClick={this.handleSavePermission}>
                  Save Permission
                </button>
              </div>
              <SecurityPermissionList roleId={this.state.selectedId} setIsLoad={this.state.setIsLoad}
                onPermissionSet={this.onPermissionItemSet} permissionTreeData={this.state.setPermissionTreeData} />
              </div>
                    </div>
                  </div>
                </div>
              </div>
            </> : null}
        </div>
      </>
    );
  }
}

